var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "quiz", attrs: { id: "quiz" } }, [
    _c("div", { staticClass: "quiz__container" }, [
      !_vm.showFeedback
        ? _c("div", { staticClass: "quiz__question" }, [
            _c("div", {
              staticClass: "rte",
              domProps: { innerHTML: _vm._s(_vm.currentQuestion.question) },
            }),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "quiz__question__answers",
                class: { answered: _vm.answered },
              },
              _vm._l(_vm.currentQuestion.answers, function (answer, index) {
                return _c(
                  "li",
                  {
                    key: answer.answer,
                    staticClass: "quiz__question__answer",
                    class: {
                      correct:
                        _vm.answered &&
                        answer.isCorrectAnswer &&
                        !_vm.quiz.hideAnswerResult,
                      selected: _vm.selectedAnswer == index,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.answerQuestion(
                          answer.isCorrectAnswer,
                          index,
                          answer
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " + _vm._s(answer.answer) + " "
                    ),
                    _vm.answered && answer.hasPercentageAnswered
                      ? _c("span", [
                          _vm._v(_vm._s(answer.percentageAnswered) + " %"),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.answered && !_vm.quiz.hideAnswerResult
              ? _c(
                  "div",
                  {
                    staticClass: "quiz__question__result",
                    class: [_vm.correct ? "correct" : "false"],
                  },
                  [_vm._v(_vm._s(_vm.correct ? "Korrekt" : "Forkert"))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.answered
              ? _c("div", {
                  staticClass: "quiz__question__feedback rte",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.feedBack(
                        _vm.uniqueAnswerFeedback,
                        _vm.currentQuestion.feedback
                      )
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "quiz__controls" }, [
              _vm.answered
                ? _c("button", { on: { click: _vm.nextQuestion } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.questionIndex + 1 == _vm.numberOfQuestions
                            ? "Afslut"
                            : "Næste spørgsmål"
                        ) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showFeedback
        ? _c("div", { staticClass: "quiz__response" }, [
            _c("div", {
              staticClass: "rte",
              domProps: { innerHTML: _vm._s(_vm.quizResponse.response) },
            }),
            _vm._v(" "),
            !_vm.quiz.hideStartOver
              ? _c("div", { staticClass: "quiz__controls" }, [
                  _c("button", { on: { click: _vm.resetQuiz } }, [
                    _vm._v("Start forfra"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.quiz.hidehideShareOnFacebook
              ? _c(
                  "div",
                  {
                    staticClass: "fb-share-button",
                    attrs: {
                      "data-href": _vm.url,
                      "data-layout": "button",
                      "data-size": "large",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "fb-xfbml-parse-ignore",
                        attrs: { target: "_blank", href: _vm.facebookShareUrl },
                      },
                      [_vm._v("Del på Facebook")]
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }